import { makeStyles } from "@material-ui/core/styles";
import {
  PrimaryColor,
  White,
  LightPrimaryColor,
  Black,
  InputColor,
  DarkGrey,
  LightGrey,
} from "../../shared/styles/colors";

export default makeStyles(() => ({
  // Settings container
  settingsContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "90vh",
    padding: "2rem",
    background: White,
    borderRadius: "8px",
    "@media (max-width: 640px)": {
      padding: "1rem",
    },
  },
  sectionMenu: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "30%",
    padding: "1rem",
  },
  menuText: {
    fontSize: "1rem",
    fontWeight: "600",
    color: DarkGrey,
    marginBottom: "1.5rem",
    marginLeft: "3rem",
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      color: PrimaryColor,
    },
  },
  menuTextActive: {
    fontSize: "1rem",
    fontWeight: "600",
    color: PrimaryColor,
    background: LightPrimaryColor,
    marginBottom: "1.5rem",
    marginLeft: "3rem",
    cursor: "pointer",
    textTransform: "none",
  },
  sectionDivider: {
    borderLeft: "1px solid lightgrey",
    marginRight: "1rem",
    height: "20rem",
    "@media (max-width: 640px)": {
      display: "none",
    },
  },
  sectionContent: {
    display: "flex",
    flexDirection: "column",
    width: "70%",
    height: "20rem",
    padding: "1rem",
    alignItems: "flex-start",
    border: "1px solid lightgrey",
    borderRadius: "8px",
    "@media (max-width: 640px)": {
      width: "100%",
      paddingLeft: "0rem",
    },
  },
  contentItem: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "2rem",
    marginLeft: "2rem",
    alignItems: "flex-start",
  },
  contentTitle: {
    fontSize: "1.2rem",
    fontWeight: "700",
    marginBottom: "1rem",
  },
  contentSubTitle: {
    fontSize: "1rem",
    fontWeight: "600",
    marginBottom: "0.5rem",
  },
  emailRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "30rem",
    maxWidth: "50rem",
  },
  // Common Styles
  headerDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  headerButton: {
    width: "100%",
    textTransform: "none",
    border: "none",
    color: White,
    background: PrimaryColor,
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5%",
  },
  title: {
    color: Black,
    fontSize: "1.3rem",
    fontWeight: "700",
  },
  form: {
    marginTop: "5%",
  },
  subTitle: {
    fontWeight: 600,
  },
  inputDiv: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "44px",
    border: "1px solid lightgrey",
    borderRadius: "8px",
  },
  input: {
    width: "95% !important",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    border: ".5px solid #7E7D7D",
    background: White,
    color: Black,
    "@media (max-width: 640px)": {
      width: "100%",
      fontSize: "0.8rem",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
  emptyInput: {
    width: "87%",
    border: "none",
    padding: "8px 16px 8px 16px",
  },
  //Details
  inputDivDetails: {
    display: "flex",
    flexDirection: "column",
    width: "100% !important",
  },
  inputDetail: {
    width: "95% !important",
    border: "none",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    background: LightGrey,
    color: InputColor,
    "@media (max-width: 640px)": {
      width: "100%",
      fontSize: "0.8rem",
    },
    "& div, input, button": {
      //child
      border: "none",
    },
  },
  textareaDetail: {
    width: "95% !important",
    height: "10rem",
    border: "none",
    borderRadius: "5px",
    padding: "0.5rem",
    margin: "0.5rem",
    background: LightGrey,
    color: InputColor,
    "@media (max-width: 640px)": {
      minHeight: "10rem",
      fontSize: "0.8rem",
      width: "100%",
      margin: 0,
      padding: 0,
    },
  },
  buttonDetail: {
    display: "flex",
    flexDirection: "column",
    padding: "0.5rem",
    margin: "0.5rem",
    width: "12rem",
    color: DarkGrey,
    background: White,
    border: "1px solid grey",
    borderRadius: "10px",
    textTransform: "none",
    alignItems: "center",
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  buttonDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "5%",
  },
  button: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "12rem",
    color: White,
    background: PrimaryColor,
    borderRadius: "10px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
    "@media (max-width: 640px)": {
      width: "auto",
      marginTop: "10%",
    },
  },
  changeButton: {
    color: PrimaryColor,
    cursor: "pointer",
    width: "100%",
    textTransform: "none",
    textWrap: "nowrap",
    "&:hover": {
      color: LightPrimaryColor,
    },
    "&:disabled": {
      color: "grey",
      cursor: "none",
    },
  },
  // Denied Access
  deniedAccessCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "100%",
    height: "90vh",
    borderRadius: "8px",
    padding: "1rem",
    backgroundColor: White,
  },
  deniedHeaderDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  warningIcon: {
    color: PrimaryColor,
  },
  deniedAccessTitle: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: PrimaryColor,
    marginLeft: "10px",
  },
  deniedTextDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  deniedAccessMessage: {
    fontSize: "1.2rem",
    color: DarkGrey,
    textAlign: "center",
    marginBottom: "1rem",
  },
}));
